import * as React from 'react';
import { SVGProps } from 'react';

const IconMBUSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 1h6v2h-.799l1.323 7H9V7h5v3h1v2h-2v3h-2v-3H5v3H3v-3H1v-2h.476L2.8 3H2V1Zm4.488 9L5.355 4h-.71l-1.133 6h2.976ZM11 9v1h1V9h-1Z"
    />
  </svg>
);
export default IconMBUSizeS;
